import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgcCommonModule } from '../../../common/common.module';
// This Module's Components
import { MytripsLoggedInComponent } from './mytrips-logged-in.component';

@NgModule({ declarations: [MytripsLoggedInComponent],
    exports: [MytripsLoggedInComponent], imports: [ReactiveFormsModule,
        CommonModule,
        NgcCommonModule,
        FormsModule,
        ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class MytripsLoggedInModule {}
